import { Archetype, Lego } from '../task/task';

type Cart = {
  tasks: (Lego | Archetype)[];
};

const CART_ID = 'cart';
const LEGOS_ID = 'legosInArchetype';

export { Cart, CART_ID, LEGOS_ID };
